import React from "react";
import { useClasses } from "../../";
import classnames from "classnames";
function isStringAndNotHidden(value) {
    return (typeof value === "string" &&
        !(value === "hidden-up" || value === "hidden-down" || value === "hidden"));
}
const getColSize = (from, props) => {
    const index = ["xl", "lg", "md", "sm", "xs"].indexOf(from);
    return index === 0 &&
        (typeof props.xl === "number" || isStringAndNotHidden(props.xl))
        ? props.xl
        : index <= 1 &&
            (typeof props.lg === "number" || isStringAndNotHidden(props.lg))
            ? props.lg
            : index <= 2 &&
                (typeof props.md === "number" || isStringAndNotHidden(props.md))
                ? props.md
                : index <= 3 &&
                    (typeof props.sm === "number" || isStringAndNotHidden(props.sm))
                    ? props.sm
                    : index <= 4 &&
                        (typeof props.xs === "number" || isStringAndNotHidden(props.xs))
                        ? props.xs
                        : typeof props.parts === "number"
                            ? props.parts
                            : 10;
};
const getColSizePrint = (props) => {
    return typeof props.print === "number" || isStringAndNotHidden(props.print)
        ? props.print
        : typeof props.xs === "number" || isStringAndNotHidden(props.xs)
            ? props.xs
            : typeof props.parts === "number"
                ? props.parts
                : 10;
};
const getColFlow = (from, props) => {
    const { parts = 10 } = props;
    const size = from === "print" ? getColSizePrint(props) : getColSize(from, props);
    if (typeof size === "string")
        return size === "rest" || size === "rest-fixed" ? "1 0 0" : `0 0 ${size}`;
    if (typeof size === "number")
        return `0 0 ${(size / parts) * 100}%`;
    else
        return "0 0 100%";
};
const getDisplay = (from, props) => {
    if (from === "xl")
        return props.xl === "hidden" ||
            props.xl === "hidden-down" ||
            props.xs === "hidden-up" ||
            props.sm === "hidden-up" ||
            props.md === "hidden-up" ||
            props.lg === "hidden-up" ||
            props.xl === "hidden-up"
            ? "none"
            : "block";
    if (from === "lg")
        return props.lg === "hidden" ||
            props.xl === "hidden-down" ||
            props.lg === "hidden-down" ||
            props.xs === "hidden-up" ||
            props.sm === "hidden-up" ||
            props.md === "hidden-up" ||
            props.lg === "hidden-up"
            ? "none"
            : "block";
    if (from === "md")
        return props.md === "hidden" ||
            props.xl === "hidden-down" ||
            props.lg === "hidden-down" ||
            props.md === "hidden-down" ||
            props.xs === "hidden-up" ||
            props.sm === "hidden-up" ||
            props.md === "hidden-up"
            ? "none"
            : "block";
    if (from === "sm")
        return props.sm === "hidden" ||
            props.xl === "hidden-down" ||
            props.lg === "hidden-down" ||
            props.md === "hidden-down" ||
            props.sm === "hidden-down" ||
            props.xs === "hidden-up" ||
            props.sm === "hidden-up"
            ? "none"
            : "block";
    if (from === "print")
        return props.xs === "hidden" ||
            props.xl === "hidden-down" ||
            props.lg === "hidden-down" ||
            props.md === "hidden-down" ||
            props.sm === "hidden-down" ||
            props.xs === "hidden-down" ||
            props.xs === "hidden-up" ||
            props.print === "hidden"
            ? "none"
            : "block";
    return props.xs === "hidden" ||
        props.xl === "hidden-down" ||
        props.lg === "hidden-down" ||
        props.md === "hidden-down" ||
        props.sm === "hidden-down" ||
        props.xs === "hidden-down" ||
        props.xs === "hidden-up"
        ? "none"
        : "block";
};
const getMaxWidth = (from, props) => {
    const { parts = 10 } = props;
    const size = from === "print" ? getColSizePrint(props) : getColSize(from, props);
    if (typeof size === "number")
        return `${(size / parts) * 100}%`;
    return undefined;
};
const styles = (theme) => ({
    col: {
        padding: (props) => `${props.vertical ? (props.spacing || 0) / 2 : 0}px ${(props.spacing || 0) / 2}px`,
        boxSizing: "border-box",
        alignSelf: (props) => (props.stretch ? "stretch" : "auto"),
        display: (props) => getDisplay("xs", props),
        flex: (props) => getColFlow("xs", props),
        maxWidth: (props) => getMaxWidth("xs", props),
        [theme.breakpoints.up("sm")]: {
            display: (props) => getDisplay("sm", props),
            flex: (props) => getColFlow("sm", props),
            maxWidth: (props) => getMaxWidth("sm", props),
        },
        [theme.breakpoints.up("md")]: {
            display: (props) => getDisplay("md", props),
            flex: (props) => getColFlow("md", props),
            maxWidth: (props) => getMaxWidth("md", props),
        },
        [theme.breakpoints.up("lg")]: {
            display: (props) => getDisplay("lg", props),
            flex: (props) => getColFlow("lg", props),
            maxWidth: (props) => getMaxWidth("lg", props),
        },
        [theme.breakpoints.up("xl")]: {
            display: (props) => getDisplay("xl", props),
            flex: (props) => getColFlow("xl", props),
            maxWidth: (props) => getMaxWidth("xl", props),
        },
        "@media print": {
            display: (props) => getDisplay("print", props),
            flex: (props) => getColFlow("print", props),
            maxWidth: (props) => getMaxWidth("print", props),
        },
    },
});
function Col({ spacing, parts = 10, xs, sm, md, lg, xl, print, children, vertical, stretch, override, }) {
    const classes = useClasses(styles, {
        spacing,
        parts,
        xs,
        sm,
        md,
        lg,
        xl,
        print,
        vertical,
        stretch,
    });
    return (React.createElement("div", { className: classnames([classes.col, override === null || override === void 0 ? void 0 : override.col]) }, children));
}
export default React.memo(Col);
